import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { KButtonModule } from 'app/common/ui/k-button/k-button.module';
import { PaypalComponent } from './paypal.component';


@NgModule({
  declarations: [
    PaypalComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    KButtonModule
  ],
  exports:[
    PaypalComponent
  ]
})
export class PaypalModule { }
